/** imported components

  * BreadcrumbsItem for ===> dynamic breadcrumb component of react.
  * $ from jquery ===> component from jquery to use jquery for the page.
  * useState, useEffect ===> React hooks (useState is a way to get/set value)
  * Helmet ===> for add specific title & CSS for the page.
  * serviceProvider for ===> working with api
  * .scss for ===> styling css file for this page.
  
**/
import React, { useEffect } from "react";
import "./skills-assessment-page.scss";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import {AssessmentWalkthroughview} from './skill-assessment-walkthrough-view.js'
import $ from "jquery";
import { useState } from "react";
import serviceProvider from '../../services/axios'
//SkillsAssessmentPageView component start
export const SkillsAssessmentPageView = (props) => {
  const quizDataItems = props.quizData;
 
  const quizDataItem = props.quizData[0];
  //defining variables here
  const [APDList, setAPDList] = useState(quizDataItem.skills);
  const [isAsstWalktrough,setIsAsstWalktrough]=useState(1);




  return (
    <>
      {/* breadcrumbs */}
      <BreadcrumbsItem to="/">Home</BreadcrumbsItem>
      <BreadcrumbsItem to="#">Skills Assessment</BreadcrumbsItem>
      <section className="skillsassessment">
        <div className="all-sellection-main">
          {/* heading */}
          <h1 className="course__overView__h1">
            <span className="skills">Skills Assessment</span>
          </h1>

          {APDList.map((items, i) => {
            return (
              // Replaced class 'active' from 'disable-card' for Not Available status also add class in "not-available" className="skill-assessment-status "
              /* this section has
                 left-img-box
                 text-box
                 angle-box
                 sellection-card-popup
              */ 
              <a data-index={0} href={`/skill-assessment/${items.course_slug}`} className={`all-sellection-card ${items.cardClass===`notavailable`?'disable-card':'active'}`} >
                <div className="left-img-box">
                  <img src={require(`../../assets/img/skillsassessment/Course-Icons${items.id}.svg`).default} alt={items.course_slug}/>
                </div>
                {/* this section has
                    text-left
                    text-cir
                */}
                <div className="text-box">
                  {/* this section has
                      heading
                      text
                  */}
                  <div className="text-left">
                    <h2 className="h1">
                      <span>{items.course_name} Assessment</span>
                    </h2>
                    {/* Added classes for status change 'to-do' for To Do, 'inprogress' for In Progress, 'complete' for Completed */}
                    <p className={`skill-assessment-status ${items.cardClass}`}>
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="status" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="6" cy="6" r="6" fill="#DB324D"/>
                      </svg>
                      <span className="res-text">{items.cardStatus}</span>
                    </p>
                  </div>
                  <div className="text-cir">
                    <svg viewBox="0 0 36 36">
                      <text
                        className="percent__text"
                        x="50%"
                        y="38%"
                        dominantBaseline="middle"
                        textAnchor="middle"
                        fontSize={6}
                        fontWeight={400}
                      >
                        Score
                      </text>
                      <text
                        className="percent__text"
                        x="50%"
                        y="63%"
                        dominantBaseline="middle"
                        textAnchor="middle"
                        fontSize={6}
                        fontWeight={700}
                      >
                        {`${items.Score}${items.Score=='-'?'':'%'}`}
                      </text>
                      <path
                        className="circle-bg"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831  a 15.9155 15.9155 0 0 1 0 -31.831"
                        stroke="#EBF5FA"
                        strokeWidth="2.4"
                        fill="none"
                      />
                      <path
                        className="circle"
                        strokeDasharray={`${items.Score=='-'?0:items.Score}, 100`}
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                        stroke="#118ACB"
                        strokeWidth="2.4"
                        fill="none"
                      />
                    </svg>
                  </div>
                </div>
                {/* this section has navigation */}
                <div className="angle-box">
                  <img
                    src={
                      require(`../../assets/img/skillsassessment/right-angle.svg`)
                        .default
                    }
                    alt="true"
                  />
                </div>
                <div className="sellection-card-popup false ">
                  <h2>{items.course_name} Assessment</h2>
                  <div>
                   
                      <p dangerouslySetInnerHTML={{ __html: items.skill_desc }}></p>
                  
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </section>
    {/*AssessmentWalkthroughview component*/}
    {(isAsstWalktrough && quizDataItem.skill_assessment1==0) && <AssessmentWalkthroughview setIsAsstWalktrough={setIsAsstWalktrough}/>}
    </>
  );
};



